<template>
	<div class="ims-map">
		<div class="map-title">
			<div class="title">IMS销售汇总:</div>
			<div class="money">{{mapTotal}}</div>
		</div>
		<div id="imsmap" style="margin:0 auto;background-color:#fff;"></div>
	</div>
</template>

<script>
	import {
		GetProvinceSalesAmount
	} from '@/api/newsapi'
	import china from '../../FormData/china.js';
	import utils from "@/common/utils.js";
	import {
		EleResize
	} from '@/common/esresize.js' // 图表自适应
	
	export default {
		data() {
			return {
				myChart: null,
				mapTotal: 0,
				options: {
					color: '#5094F6',
					tooltip: {
						trigger: 'item',
						confine: true,
						hideDelay: 2000,
						formatter(params) {
							if (params && params.data) {
								let viewStr =
									`<div>
										<div>${params.data.name}</div>
										<div style="display:flex;flex-direction: column;">
											<div style="font-size:14px;font-weight:400;margin:0px 20px 0px 8px;">金额 / 占比</div>
											<div style="font-size:14px;font-weight:500;margin:0px 20px 0px 8px;">${params.data.valueString}元 / ${params.data.ratio}%</div>
										</div>
									</div>`;
								return viewStr;
							}
						}
					},
					grid: {
						bottom: 30,
					},
					toolbox: {
						show: true,
						top: 8,
						right: 20,
						orient: 'vertical',
						feature: {
							saveAsImage: {
								icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAA2ZJREFUWEfFl09oE0EUh783m4oHBRGFHnqImMTqSUFBUVAPgj0IHhS8iIoetKS1gqIHxYBeRMXWhFKxoAfBgwcLIgge9KAgWLAH0ZpY7EGxoIJgD7HZ3ZHdTbabv91ognNakpn3++bNe2/eCP95SJV+9PBiFi1dg82yptm09YWp4Y/NrCsHSCQvAudAFjdjJDDXRBubyA1OuL+t612CabxBk6fwaxPTd/OVducBEskUiAPwL2MWy9rge6H7eBS745NrUBVWMTkyXRvAJVXf3J1rHiP6NMqsol2QTKnvvBue9eeFBliT3IiW195CvZZsZnJBsTATQgPEkjtQ8qyRq8Lozc9JRSBl8l8A4snLiJzF5gyRwlhZDJgde1HcQOsT5DIjDrAXhK30QKJ/FPRR7zQZRBio+obrZNOn2wPgpd4TYGudY3tJxNpdCtbWe2A+/2tBlIm3xwOlbVd7whM3VRe2zPIx/bm9ACVPFIwRRJtE7CS/6cQw3gM/yaZXth+gMgiCwZ5Nu8ffnhioVzT+GsA5z4JxFmEzWp7TYQ6VldywVeqvAKK9nSwyHgKbAzrjzFl7mB6eqdZORUj8uAH6mPefGiS7/IJbGZsGiPV1oXgKdBeFnNTaXfz+jCU9TN18W1aC4z/uI+yrABtHFfZjRqJ+yV8wBhLJbnDvh07ARPQRPmTukeg/APoO4PQMs1iyn6mbTyAVISgu3MLWeUROFivhT5SMorVbAWkIYKsucN2+whVBHySbGfN3lTi5DewHPhwygNY7/J1rPUQu45XgRHIviANc3mHVBXAuCpGrwBJPXPWQHXpRddare2MYxqPA8XhTguKlRd0DUWzLAd7o26kLMK80A3pnw94gOrCMDmsMYbsfFxFrbe0McYLz+wiId1EtADCJZe0J12C6hkdBDhVdMMGc3VMzQ0JlATLBnFnbQKN8j/edR7jkewK9q8p7oQAsKx5u5zVoghmiuUwufaFsViiAOt1r2GKH118ewuZK6cbz19YFiPeuR4w3XhRbG8gNe319q0esbx8KJxsqgtB7DX0t5uorHPdpJwVbOESvQOQaEAVekU1vcawHHib9x0DfbqFkPVMmqJ2l2lLxNOs/gNaXEGJtAhkHdSpY2Kofp46yc/3atlOGWzfy+ZnGb8PWSTVl6Q8eGbAwgbTYagAAAABJRU5ErkJggg==',
								name: 'IMS销售汇总',
								show: true
							},
							myFull: { // 全屏
								show: true,
								title: '全屏',
								icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
								onclick: (e) => {
									let domName = document.getElementById('imsmap');
									// 全屏查看
									if (domName.requestFullScreen) { // HTML W3C 提议
										domName.requestFullScreen()
									} else if (domName.msRequestFullscreen) { // IE11
										domName.msRequestFullScreen()
									} else if (domName.webkitRequestFullScreen) { // Webkit
										domName.webkitRequestFullScreen()
									} else if (domName.mozRequestFullScreen) { // Firefox
										domName.mozRequestFullScreen()
									}
									// 退出全屏
									if (domName.requestFullScreen) {
										document.exitFullscreen()
									} else if (domName.msRequestFullScreen) {
										document.msExitFullscreen()
									} else if (domName.webkitRequestFullScreen) {
										document.webkitCancelFullScreen()
									} else if (domName.mozRequestFullScreen) {
										document.mozCancelFullScreen()
									}
								}
							}
						}
					},
					visualMap: {
						orient: 'horizontal',
						//bottom: 0,
						//left: 0,
						min: 0,
						max: 0,
						itemHeight: 288,
						text: ['max', 'min'],
						realtime: false,
						calculable: true,
						align: 'auto',
						inRange: {
							color: ['#ecf2fe', '#d4e3fc', '#bbd3fb', '#96bbf8', '#699ef5', '#4787f0', '#266fe8', '#0052d9',
								'#0034b5', '#001f97'
							]
						}
					},
					series: [{
						name: '中国地图',
						type: 'map',
						map: 'china',
						roam: true,
						zoom: 2,
						label: {
							show: true,
							fontSize: '10',
							color: '#767474',
						},
						top: 100,
						itemStyle: {
							areaColor: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0,
									color: '#5094F6' // 0% 处的颜色
								}, {
									offset: 1,
									color: '#65AAFF' // 100% 处的颜色
								}],
								global: false // 缺省为 false
							},
							borderColor: "#6AD6F9",
						},
						select: {
							label: {
								show: true,
								fontSize: '10',
								color: '#333333',
							},
							itemStyle: {
								areaColor: '#E71D43', //鼠标选择区域颜色
								shadowBlur: 20,
								borderWidth: 2,
							}
						},
						data: []
					}]
				}
			}
		},
		mounted() {
			this.init();
		},
		methods: {
			async init(query) {
				let _this = this;
				this.myChart = this.$MyEcharts.init(document.getElementById('imsmap'));
				// 自适应
				var listener = function() {
					_this.myChart.resize()
				}
				EleResize.on(document.getElementById('imsmap'), listener)
				this.myChart.clear();
				const res = await this.getData(query);
				this.options.series[0].data = res.data;
				this.options.visualMap.min = res.min;
				this.options.visualMap.max = res.max;
				this.$MyEcharts.registerMap('china', china);
				this.myChart.clear();
				this.myChart.setOption(this.options);

				this.myChart.on('select', function(e) { //选中
					_this.$emit('select', {
						query: query,
						name: _this.options.series[0].data[e.dataIndexInside].yname
					})
				})

				this.myChart.on('unselect', function(e) { //反选
					_this.$emit('select', '')
				})
			},
			getData(e = {}) {
				return new Promise(resolve => {
					GetProvinceSalesAmount(e).then(res => {
						let {
							code,
							data,
							message
						} = res;
						if (code === 0) {
							let dataList = [];
							// isMapShow.value = data.CanShow;
							this.mapTotal = data.TotalString;
							if (data.data.length) {
								data.data.forEach(item => {
									dataList.push({
										ratio: item.MoneyRatio,
										name: item.Name.replace('省', '').replace('市', '')
											.replace(
												'自治区', '').replace('壮族', '').replace('回族',
												'')
											.replace('维吾尔', '').replace('特别行政区', ''),
										yname: item.Name,
										value: item.Value,
										valueString: item.ValueString
									})
								})
							}
							resolve({
								data: dataList,
								min: this.getMaxMin(data.data)[0],
								max: this.getMaxMin(data.data)[1]
							});
						}
					})
				});
			},
			getMaxMin(data) {
				let numArr = [...new Set(data.map(item => item.Value))].sort((a, b) => a - b);
				return [numArr[0], numArr[numArr.length - 1]]
			}
		}
	}
</script>

<style lang="less">
	.ims-map {
		flex: 1;
		//max-width: 900px;
		background: #ffffff;
	}

	#imsmap {
		height: 400px;
		//margin-top: 16px;
		padding: 16px;
	}

	.map-title {
		// display: flex;
		// justify-content: center;
		// background: #ffffff;
		// padding: 15px 0px;

		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		padding: 12px;

		.title {
			font-size: 16px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #333333;
		}

		.money {
			font-size: 32px;
			font-family: D-DIN-Bold, D-DIN;
			font-weight: 700;
			line-height: 40px;
			letter-spacing: 5px;
			// text-shadow: 0px 2px 8px rgba(27, 126, 242, 0.32);
			background: linear-gradient(180deg, rgba(27, 126, 242, 0.48) 0%, #1B7EF2 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			margin: 0px 10px;
		}
	}
</style>